export const Utils = {
  async generatePdf(element: HTMLElement, filename: string) {
    const html2canvas = (await import("html2canvas")).default;
    const jsPdf = (await import("jspdf")).default;
    const FILE_WIDTH = 595;
    // 生成canvas
    const canvas = await html2canvas(element, {
      scrollX: 0,
      scrollY: 0
    });

    const imageHeight = (canvas.height / canvas.width) * FILE_WIDTH;

    // canvas 转 Pdf
    const doc = new jsPdf(imageHeight > FILE_WIDTH ? "p" : "l", "pt", [
      imageHeight,
      FILE_WIDTH
    ]);
    doc.addImage(
      canvas.toDataURL("image/jpeg", 1.0),
      "JPEG",
      0,
      0,
      FILE_WIDTH,
      imageHeight
    );
    doc.save(filename);
  },

  download(url: string, name?: string) {
    const a = document.createElement("a");
    a.href = url;
    if (name) {
      a.download = name;
    }
    a.click();
  }
};
